const ExemplePath = {
    EXEMPLE_HOME: '/home',
    EXEMPLE_VERSION: '/version',
};

const MapPath = {
    MAP: '/map',
};

const Path = {
    ...MapPath,
    ...ExemplePath,
};

export default Path;
